exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toggle.ng-switch{\r\n    transition:0.5s linear all;\r\n}", ""]);
